<template>
  <div v-if="message" class="error-message-text"> 
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'error-message-box',
  props: {
    message: {
      type: String
    }
  }
}
</script>

<style lang="scss">
  .error-message-text{
    color: #f86c6b;
  }

  .remove-margin-bottom {
    margin-bottom: 0 !important;
  }
  .add-margin-bottom {
    margin-bottom: 1rem !important;
  }

</style>



// WEBPACK FOOTER //
// ErrorMessageBox.vue?123ce595